import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { updateProcessingStageStep, updateJobServiceTransition } from "requesters/jobServiceRequester";
import { getBaseUrl, getCurrentRole } from "../../../../../reducers";
import CommentBox from "../CommentBox";
import ConfirmationModal from "../../../modals/ConfirmationModal";
import CheckingStep from "./CheckingStep";
import FlagJobServiceModal from "../../../modals/FlagJobServiceModal";
import { ADMIN } from "../../../../../../../utils/constants";

const ProcessingNavvis = ({
  jobService, reloadData, comment, setComment
}) => {
  const {
    attributes: {
      completedStepsForProcessingNavvisOptions,
      jobNo,
      projectXJobNo,
      forProjectX,
      is3D,
      jobTitle
    }, id
  } = jobService
  const baseUrl = useSelector(getBaseUrl);
  const currentRole = useSelector(getCurrentRole)
  const isAdmin = currentRole.includes(ADMIN)
  const [checkingSteps, setCheckingSteps] = useState(completedStepsForProcessingNavvisOptions)
  const [requesting, setRequesting] = useState(false)
  const [targetStep, setTargetStep] = useState(null)
  const [showTransitionConfirmation, setShowTransitionConfirmation] = useState(false)
  const [showAddFlagModal, setShowAddFlagModal] = useState(false)

  const onClickStep = useCallback(step => {
    setRequesting(true)
    setTargetStep(step)
    // eslint-disable-next-line
    const newCheckingSteps = checkingSteps.map(s => s.value === step.value ? { ...s, checked: !s.checked } : s)
    setCheckingSteps(newCheckingSteps)
    updateProcessingStageStep(baseUrl, id, step.value, !step.checked)
    .then(res => {
      if (res.status === 200) {
        reloadData()
        setRequesting(false)
        setTargetStep(null)
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
  }, [baseUrl, id, reloadData])

  const sendTo3dProcessing = () => {
    setRequesting(true)
    updateJobServiceTransition(baseUrl, id, "move-to-3d-processing", comment)
    .then(res => {
      if (res.status === 200) {
        window.location.reload()
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
    .finally(() => setRequesting(false))
  }

  const sendToVirtualDrafting = () => {
    setRequesting(true)
    updateJobServiceTransition(baseUrl, id, "move-to-virtual-drafting", comment)
    .then(res => {
      if (res.status === 200) {
        window.location.reload()
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
    .finally(() => setRequesting(false))
  }

  useEffect(() => {
    setCheckingSteps(completedStepsForProcessingNavvisOptions)
  }, [completedStepsForProcessingNavvisOptions])

  const allStepsCompleted = checkingSteps.every(step => step.checked)
  const displayJobNo = forProjectX ? projectXJobNo : jobNo

  const generateCheckingSteps = useMemo(() => (
    checkingSteps.map((step, idx) => (
      <CheckingStep
        key={step.value}
        step={step}
        idx={idx}
        onClickStep={onClickStep}
        requesting={requesting}
        targetStep={targetStep} />
    ))
  ), [checkingSteps])

  const AddFlagSection = () => {
    return (
      <div className="text-right">
        <button className="btn" type="button" onClick={() => setShowAddFlagModal(true)}>
          <i className="bi bi-flag-fill mr-2"></i>
          Add Flag
        </button>
        <FlagJobServiceModal
          show={showAddFlagModal}
          onHide={() => setShowAddFlagModal(false)}
          jobService={jobService}
          reloadData={reloadData} />
      </div>
    )
  }

  const sendTo3dProcessingButton = () => (
    <div className="mr-2">
      <button
        className={`btn ${(allStepsCompleted || isAdmin) ? "btn-outline-primary" : "btn-outline-secondary"}`}
        type="button"
        disabled={(!isAdmin && !allStepsCompleted) || requesting}
        onClick={() => setShowTransitionConfirmation(true)}>
        3D Processing
      </button>
      <ConfirmationModal
        jobNo={displayJobNo}
        jobTitle={jobTitle}
        show={showTransitionConfirmation}
        resetState={() => setShowTransitionConfirmation(false)}
        sendTo={sendTo3dProcessing}
        messageType="3D Processing" />
    </div>
  )

  const sendToVirtualDraftingButton = () => (
    <div className="mr-2">
      <button
        className={`btn ${(allStepsCompleted || isAdmin) ? "btn-outline-primary" : "btn-outline-secondary"}`}
        type="button"
        disabled={(!isAdmin && !allStepsCompleted) || requesting}
        onClick={() => setShowTransitionConfirmation(true)}>
        Virtual Drafting
      </button>
      <ConfirmationModal
        jobNo={displayJobNo}
        jobTitle={jobTitle}
        show={showTransitionConfirmation}
        resetState={() => setShowTransitionConfirmation(false)}
        sendTo={sendToVirtualDrafting}
        messageType="Virtual Drafting" />
    </div>
  )
  const sendToButtons = () => {
    const shouldBeSendTo3dProcessing = is3D

    return (
      shouldBeSendTo3dProcessing ? sendTo3dProcessingButton() : sendToVirtualDraftingButton()
    )
  }

  return (
    <div className="processing-navvis-section">
      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <div className="row justify-content-end align-baseline px-4">
            {AddFlagSection()}
          </div>
          <div className=" p-4">
            {generateCheckingSteps}
          </div>
        </div>
      </div>
      <div className="transition-comment">
        <CommentBox comment={comment} setComment={setComment} />
        <div className="row mt-4">
          <div className="mr-4 pt-2">Send to</div>
          {sendToButtons()}
        </div>
      </div>
    </div>
  )
}

export default ProcessingNavvis